/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManufacturerReference
 */
export interface ManufacturerReference {
    /**
     * 
     * @type {string}
     * @memberof ManufacturerReference
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturerReference
     */
    readonly name: string;
}

/**
 * Check if a given object implements the ManufacturerReference interface.
 */
export function instanceOfManufacturerReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ManufacturerReferenceFromJSON(json: any): ManufacturerReference {
    return ManufacturerReferenceFromJSONTyped(json, false);
}

export function ManufacturerReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManufacturerReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ManufacturerReferenceToJSON(value?: ManufacturerReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

